/**
 * Service for managing pinned gifs for a user.
 *
 * Responsibilities:
 * - Fetch pinned gifs list for a username.
 * - Pin/unpin a gif.
 * - Reorder pinned gifs.
 */
import type { IGifList } from "../types";
import type { ApiClient } from "@/common/api/http/types";

export default class PinsService {
  public constructor(private readonly client: ApiClient) {}

  async getPinGifs(userName: string): Promise<IGifList> {
    return await this.client.get(`v2/pins/${userName}`);
  }

  async addPinGif(gif: string): Promise<void> {
    return await this.client.post("v2/pins", { gif });
  }

  async unPinGif(gif: string): Promise<void> {
    return await this.client.delete(`v2/pins/${gif}`);
  }

  async reorderPinGifs(gifs: string[]): Promise<void> {
    return await this.client.put("v2/pins", { ids: gifs });
  }
}
